export const logBuckets = {
    dev: 'trqk-client-log-dev',
    staging: 'trqk-client-log-staging',
    prod: 'trqk-client-log-prod',
    test: 'trqk-eventbridge-log',
};

export const inputIds = {
    logsUserId: 'logsUserId',
    logsMaxResults: 'logsMaxResults',
    logsDateYear: 'logsDateYear',
    logsDateMonth: 'logsDateMonth',
    logsDateDay: 'logsDateDay',
    logsDateHours: 'logsDateHours',
    logsDateMinutes: 'logsDateMinutes',
    logsDateSeconds: 'logsDateSeconds',
    logsEventType: 'logsEventType',
    logsRangeValue: 'logsRangeValue',
};
